var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"mathJaxEl",staticClass:"1123 mathJaxEl",domProps:{"innerHTML":_vm._s(_vm.formula)}})}
var staticRenderFns = []

export { render, staticRenderFns }